import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { takeUntil } from "rxjs/operators";
import { Goods } from "../../models/goods.model";

@Component({
  selector: "goods-import-export-form",
  templateUrl: "./goods-import-export-form.component.html",
  styleUrls: ["./goods-import-export-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoodsImportExportFormComponent extends BaseFormComponent<Goods> {
  isloading: boolean = false;
  gridInfo: GridColumnInfoDetail[];
  GoodsList: Goods[] = [];
  public hColumns: form_control[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "Goods";
    this.label = "استخراج و دریافت";
    super.ngOnInit();
    //await this.setData();
  }
  async setColumns() {
    await super.setColumns();
    this.hColumns = [];
    this.hColumns = this.hColumns;
  }
  addControl(): void {
    this.setValue("isFirstRowColumnsName", true);
  }
  async onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length > 1) {
      alert("انتخاب بیش از یک فایل مجاز نیست.");
      return;
    } else {
      var file = target.files[0] as File;
      let fileReader: FileReader = new FileReader();
      fileReader.onloadend = () => {
        var fileContent = fileReader.result.toString();
        this.GoodsList = JSON.parse(fileContent);
        this.saveData().then();
      };
      fileReader.readAsText(file);
    }
  }
  async saveData() {
    await this.httpCommonService
      .createlist("Goods/ImportExport", this.GoodsList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          this.sts.showToast("success", "", "اطلاعات با موفیت ذخیره شد.");
        },
        (error) => this.getFailedHelper(error)
      );
  }
  saveText(text, filename) {
    var a = document.createElement("a");
    a.setAttribute("href", "data:text/plain;charset=utf-u," + encodeURIComponent(text));
    a.setAttribute("download", filename);
    a.click();
  }
  async exportData() {
    await this.httpCommonService
      .getList("Goods")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.GoodsList = data as Goods[];
            this.saveText(JSON.stringify(this.GoodsList), "Goods.json");
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  public cancel() {
    this.close();
  }
}
